import makeLookup from './makeLookup'

var empty = {}
var table = {
  p: makeLookup('address,article,aside,blockquote,div,dl,fieldset,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,main,nav,ol,p,pre,section,table,ul'),
  li: makeLookup('li'),
  dt: makeLookup('dt,dd'),
  dd: makeLookup('dt,dd'),
  rb: makeLookup('rb,rt,rtc,rp'),
  rt: makeLookup('rb,rt,rtc,rp'),
  rtc: makeLookup('rb,rtc,rp'),
  rp: makeLookup('rb,rt,rtc,rp'),
  optgroup: makeLookup('optgroup'),
  option: makeLookup('option,optgroup'),
  thead: makeLookup('tbody,tfoot'),
  tbody: makeLookup('tbody,tfoot'),
  tfoot: makeLookup('tbody'),
  tr: makeLookup('tr'),
  td: makeLookup('td,th'),
  th: makeLookup('td,th'),
}
export default function(closee, closer) {
  var lookup = table[closee] || empty
  return !!lookup[closer]
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/isClosedBy.js